(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sliderTrack = document.getElementById('customCollectionSliderTrackV2');
  const prevBtn = document.querySelector('.prev-btn-custom-v2');
  const nextBtn = document.querySelector('.next-btn-custom-v2');
  
  if (!sliderTrack || !prevBtn || !nextBtn) return;
  
  // Get the width of one item plus gap
  function getScrollAmount() {
    const firstItem = sliderTrack.querySelector('.custom-collection-slide-item-v2');
    if (!firstItem) return 300;
    const gap = 20;
    return firstItem.offsetWidth + gap;
  }
  
  // Arrow button navigation
  function scrollSlider(direction) {
    const scrollAmount = getScrollAmount();
    const scrollValue = direction === 'next' ? scrollAmount : -scrollAmount;
    sliderTrack.scrollBy({
      left: scrollValue,
      behavior: 'smooth'
    });
  }
  
  nextBtn.addEventListener('click', () => scrollSlider('next'));
  prevBtn.addEventListener('click', () => scrollSlider('prev'));
  
  // Mouse drag functionality
  let isMouseDown = false;
  let startX;
  let scrollLeft;
  let hasMoved = false;
  
  sliderTrack.addEventListener('mousedown', (e) => {
    isMouseDown = true;
    hasMoved = false;
    startX = e.pageX - sliderTrack.offsetLeft;
    scrollLeft = sliderTrack.scrollLeft;
    sliderTrack.style.scrollBehavior = 'auto';
  });
  
  sliderTrack.addEventListener('mouseleave', () => {
    isMouseDown = false;
    sliderTrack.style.scrollBehavior = 'smooth';
  });
  
  sliderTrack.addEventListener('mouseup', () => {
    isMouseDown = false;
    sliderTrack.style.scrollBehavior = 'smooth';
  });
  
  sliderTrack.addEventListener('mousemove', (e) => {
    if (!isMouseDown) return;
    e.preventDefault();
    hasMoved = true;
    const x = e.pageX - sliderTrack.offsetLeft;
    const walk = (x - startX) * 2;
    sliderTrack.scrollLeft = scrollLeft - walk;
  });
  
  // Prevent click on links when dragging
  const links = sliderTrack.querySelectorAll('.custom-collection-slide-link-v2');
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        hasMoved = false;
      }
    });
  });
  
  // Touch support for mobile - simplified
  let touchStartX = 0;
  let touchStartTime = 0;
  let touchHasMoved = false;
  
  sliderTrack.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartTime = Date.now();
    touchHasMoved = false;
  }, { passive: true });
  
  sliderTrack.addEventListener('touchmove', (e) => {
    if (!touchStartX) return;
    const touchX = e.touches[0].clientX;
    const diff = Math.abs(touchX - touchStartX);
    if (diff > 10) {
      touchHasMoved = true;
    }
  }, { passive: true });
  
  sliderTrack.addEventListener('touchend', (e) => {
    const touchEndTime = Date.now();
    const touchDuration = touchEndTime - touchStartTime;
    
    // If touch was quick (< 200ms) and didn't move much, it's a tap
    if (touchDuration < 200 && !touchHasMoved) {
      // Let the click event fire naturally
      return;
    }
    
    // If touch moved or was long, prevent click
    if (touchHasMoved) {
      e.preventDefault();
      const clickHandler = (clickEvent) => {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        e.target.removeEventListener('click', clickHandler, true);
      };
      e.target.addEventListener('click', clickHandler, true);
      
      setTimeout(() => {
        touchHasMoved = false;
      }, 100);
    }
    
    touchStartX = 0;
    touchStartTime = 0;
  }, { passive: false });
})();

  } catch(e) { console.error(e); }
})();
})();
